import type { TableProps } from '../../Table';
import type { GetRowKey } from './table-body-components/table-row/table-row-types/get-row-key';
import TableRow from './table-body-components/table-row/TableRow';

export type TableBodyProps<Row> = Pick<TableProps<Row>, 'columns' | 'rowClassName' | 'cellClassName' | 'sortBy' | 'sortDirection' | 'getRowKey' | 'rows' | 'onRowClick'> ;

export default function TableBody<Row>({ rows, columns, rowClassName, cellClassName, sortBy, sortDirection, getRowKey, onRowClick }: TableBodyProps<Row>) {
  const sortedRows = sortBy ? sort(rows, sortBy, sortDirection) : rows;

  return (
    <tbody>
      { 
      sortedRows.map((row, rowIndex) => (
        <TableRow
          key={getKey(row, rowIndex, getRowKey)}
          {...{ columns, rowIndex, row, rowClassName, cellClassName, onRowClick }}
        />
      ))
      }
    </tbody>
  );
}

function getKey(row: any, rowIndex: number, getRowKey?: GetRowKey<any>) {
  if (getRowKey) {
    return getRowKey(row);
  }

  if (row.id) {
    return row.id;
  }

  return rowIndex.toString();
}

function sort<Row>(rows: Row[], sortBy: Required<TableProps<Row>>['sortBy'], sortDirection: TableProps<Row>['sortDirection']) {
  const ascendingRows = rows.sort((row1: Row, row2: Row) => {
    const aValue = typeof sortBy === 'function' ? sortBy(row1) : row1[sortBy];
    const bValue = typeof sortBy === 'function' ? sortBy(row2) : row2[sortBy];

    if (aValue > bValue) {
      return 1;
    }

    if (aValue < bValue) {
      return -1;
    }

    return 0;
  });

  return sortDirection === 'desc' ? ascendingRows.reverse() : ascendingRows;
}
